import { PeopleForm } from 'components/forms/people-form/people-form';
import { useCallback } from 'react';
import { closeModal } from 'store/modals/modals.slice';
import { removePeopleFromStore } from 'store/people/people.slice';
import { getPeopleThunk } from 'store/people/people.thunks';

import { MODAL_PEOPLE } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const PeopleModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === MODAL_PEOPLE),
  );
  const isDirty = useAppSelector((state) => state.formIsDirty.isDirty);

  const handleClose = useCallback(() => {
    dispatch(closeModal({ name: MODAL_PEOPLE }));
    dispatch(removePeopleFromStore());
    dispatch(getPeopleThunk());
  }, [dispatch]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal formIsDirty={isDirty} close={handleClose}>
      <PeopleForm />
    </Modal>
  );
};
